export default "__VITE_ASSET__a8d77a99__"